import I18n from 'core/i18n'
import dompurify from 'dompurify'
import moment from 'moment'
import { TourGuideRequestStatus } from 'static/interfaces'

export function isTouchDevice() {
  const regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return window.navigator.userAgent.search(regexp) !== -1
}

export function getStripePublicKey(): any {
  const element: any = document.querySelector('meta[name=stripe-public-key]')

  return element ? element.content : ''
}

export function withHtmlTag(text: string): string {
  const withLinkText = dompurify.sanitize(text, {
    ALLOWED_TAGS: ['a', 'span', 'img'],
    ALLOWED_ATTR: ['href', 'target', 'class', 'src'],
  })
  return withLinkText
}

// 管理者でもエージェントでもオーナーでもないユーザーのみお気に入りが可能
export const checkLikeable = (post, user): boolean => {
  if (!user || !post) {
    return false
  }
  const { admin, agent, id } = user
  const { is_owner, user: post_user } = post

  return !admin && !agent && (!is_owner || post_user?.id !== id)
}

const getMoment = (locale, dateStr, format) => {
  if (locale === 'ja') {
    return moment(dateStr, format)
  }
  return moment(dateStr)
}

export const getFormattedFromDateTime = (locale, dateTimeSrting, format) => {
  return getMoment(locale, dateTimeSrting, 'YYYYMMDD HH:mm').format(format)
}

export const getTourGuideStatusLabel = (
  requestStatus: TourGuideRequestStatus = TourGuideRequestStatus.nothing
) => {
  return I18n.t(`tour_guide_request_status.${requestStatus}`)
}

export const getStatusBadgeTypeFromStatus = (
  status: TourGuideRequestStatus | 'agent_official_requested' | 'guide_approved' | 'guide_declined'
) => {
  if (
    !status ||
    status === TourGuideRequestStatus.nothing ||
    status === TourGuideRequestStatus.agent_canceled ||
    status === TourGuideRequestStatus.agent_pre_canceled ||
    status === TourGuideRequestStatus.agent_rejected
  ) {
    return 'empty'
  }
  if (
    status === TourGuideRequestStatus.agent_pre_requested ||
    status === TourGuideRequestStatus.guide_applied
  ) {
    return 'usually'
  }
  if (status === TourGuideRequestStatus.guide_approved) {
    return 'success'
  }
  if (status === TourGuideRequestStatus.guide_declined) {
    return 'caution'
  }
  return 'info'
}
